import { normalize } from 'normalizr';
import { ActionTree } from 'vuex';
import { reply } from '@descomplica/dex-store/lib/normalizr_schema';
import { dexMutation } from '@/helpers/graphql';
import { ReplyState } from './state';
import RootState from '@/store/root_state';
import { createReplyMutation } from '@/store/queries/dexQueries';

const actions: ActionTree<ReplyState, RootState> = {
  async CREATE_REPLY({ commit }, payload) {
    const { listId, questionId, userId, assertionId, answer } = payload;

    const response = await dexMutation(createReplyMutation, {
      listId,
      questionId,
      userId,
      assertionId,
      answer,
    });

    const normalizedResponse = normalize(response.data.createReply, { reply });
    commit('SET_REPLIES', normalizedResponse.entities);
    commit('SET_LISTS', normalizedResponse.entities);

    // Solution contents
    commit('SET_SOLUTIONS', normalizedResponse.entities);
    commit('SET_CONTENTS', normalizedResponse.entities);
    commit('SET_TEXTS', normalizedResponse.entities);
    commit('SET_IMAGES', normalizedResponse.entities);
    commit('SET_VIDEOS', normalizedResponse.entities);
    commit('SET_USERS', normalizedResponse.entities);
  },
};

export default actions;
